import { Download } from 'lucide-react'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { format, parseISO } from 'date-fns'
import { ptBR } from 'date-fns/locale'

type Props = {
  downloadedAt: string | null
}

export function DownloadedIndicator({ downloadedAt }: Props) {
  const label = downloadedAt
    ? `Baixado em ${format(parseISO(downloadedAt), "dd/MM/yyyy 'às' HH:mm", { locale: ptBR })}`
    : 'Não baixado'

  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className="inline-flex items-center justify-center cursor-help"
            style={{
              color: downloadedAt ? 'var(--evertec-blue-500)' : 'var(--ev-fg-faint)',
              opacity: downloadedAt ? 1 : 0.4,
            }}
            aria-label={label}
          >
            <Download size={15} strokeWidth={1.75} />
          </span>
        </TooltipTrigger>
        <TooltipContent side="top">
          <p className="text-xs">{label}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
